import { Deserializable } from '../deserializable';

export class LookupCurrencies implements Deserializable {

    id: number;
    name: string;
    code: string;
    symbol: string;
    
    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}

